module.exports = __webpack_public_path__ + "media/images/marketing-banner/installation-1-85773738c342f2c5ae22c0369bb13bce.png";